import { render } from "./AppHero.vue?vue&type=template&id=c0caf55e"
const script = {}

const cssModules = script.__cssModules = {}
import style0 from "./AppHero.vue?vue&type=style&index=0&id=c0caf55e&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script